/* unplugin-vue-components disabled */import script from "./ApiFaultNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiFaultNotice.vue?vue&type=script&setup=true&lang=js"

import "./ApiFaultNotice.vue?vue&type=style&index=0&id=c9b1485c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9b1485c"]])

export default __exports__